export const QuestionActionTypes={
    SET_FETCHED_QUESTIONS_TO_STATE:'SET_FETCHED_QUESTIONS_TO_STATE',
    SET_SELECTED_QUESTION:'SET_SELECTED_QUESTION',
    SELECTED_QUESTION_NEXT:'SELECTED_QUESTION_NEXT',
    SELECTED_QUESTION_PREVIOUS:'SELECTED_QUESTION_PREVIOUS',
    SET_SELECTED_ANSWER:'SET_SELECTED_ANSWER',
    // SET_RECENT_FETCHED_TIME:"SET_RECENT_FETCHED_TIME"
}